import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTitle } from '../../Application';
import LoginView from '../../ui/components/Login/Login';
import {authenticate, deauthenticate, clearError} from '../../Authentication/actions';
import toast from '../../utils/ToasterService';
import { pingURL, sendRequest } from '../../services/api/apiClient';
import {t} from 'i18next'

const title = 'Anmelden';

const mapStateToProps = state => ({
  title: state.application.title,
  authenticated: state.authentication.authenticated,
  error: !!state.authentication.errors,
});

const mapDispatchToProps = dispatch => ({
  authenticate: (username, password) => dispatch(authenticate(username, password)),
    deauthenticate: () => dispatch(deauthenticate()),
    clearError: () => dispatch(clearError()),
});

/**
 * Login
 */
class Login extends PureComponent {
  static propTypes = {
    authenticate: PropTypes.func.isRequired,
    authenticated: PropTypes.bool,
    error: PropTypes.bool,
  }

  static defaultProps = {
    authenticated: false,
    error: false,
  }

  checkConnectionToServer=()=>{
    sendRequest('get', pingURL)
    .then(() => {
      //console.log('Response Ok: Server working!');
    })
    .catch(error => {
      //console.error('Cannot Connect to Server:', error);
      //Server Failure Toast here
      toast.error(t('Global.toast_server_disconnect'));
    });
  }

  handleLogin = (username, password) => {
    this.checkConnectionToServer()
    this.props.authenticate(username, password);
  }

  render() {
    this.checkConnectionToServer()
    return (
      <LoginView deauthenticate={this.props.deauthenticate} onLogin={this.handleLogin} error={this.props.error} clearError={this.props.clearError} />
    );
  }
}

export default withTitle(withRouter(connect(mapStateToProps, mapDispatchToProps)(Login)), title);
